import { render, staticRenderFns } from "./v-snack.vue?vue&type=template&id=1602cf5d&"
import script from "./v-snack.vue?vue&type=script&lang=js&"
export * from "./v-snack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports